import { DataLayerManagerInterface } from './dataLayerManager/abstractDataLayerManager';
import {
    LoginAndRegisterEvent,
    SpecificGaEvent,
    TrackLoginAndRegisterActions,
    TrackLoginAndRegisterOptions,
} from './types';

export default class LoginAndRegisterTracking {
    private dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    private trackLoginAndRegistration(event: SpecificGaEvent, options: TrackLoginAndRegisterOptions) {
        this.dataLayerManager.sendSpecificEvent(event, {
            ...options,
        });
    }

    public trackSuccessfulRegistration() {
        this.trackLoginAndRegistration(LoginAndRegisterEvent.SuccessfulRegistration, {
            action: TrackLoginAndRegisterActions.SuccessfulRegistration,
            label: 'Login and Register Overlay',
        });
    }
}
